const bs = [
  {
    id: '3',
    title: 'IuteCredit Novo Sarajevo (Sarajevo 3)',
    streetAddress: 'Zmaja od Bosne 50, Općina Novo Sarajevo, Sarajevo 71000',
    mapUrl: 'https://maps.google.com/maps?ll=43.853952,18.389015&z=16&cid=1144787395965979353',
    openingTimes: 'PON-PET 8:00-19:00, SUB-NED 09:00-17:00',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  },
  {
    id: '4',
    title: 'IuteCredit Zenica',
    streetAddress: 'Londža br. 92, Zenica 72000',
    mapUrl: 'https://maps.google.com/maps?ll=44.197009,17.914771&z=16&cid=4007873762858220508',
    openingTimes: 'PON-PET 8:00-16:30',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  },
  {
    id: '5',
    title: 'IuteCredit Istočno Sarajevo',
    streetAddress: 'Hilandarska br. 13, Istočno Sarajevo 71123',
    mapUrl: 'https://maps.google.com/maps?ll=43.8190589,18.36403621&z=16&cid=7406567814804770543',
    openingTimes: 'PON-PET 8:00-19:00, SUB 09:00-17:00',
    phone: '+387 51 981 330',
    email: 'info@iutecredit.ba'
  },
  {
    id: '6',
    title: 'IuteCredit Banja Luka',
    streetAddress: 'Gundulićeva br. 52, Banja Luka 78000',
    mapUrl: 'https://maps.google.com/maps?ll=44.773518,17.199096&z=16&cid=868606192412116586',
    openingTimes: 'PON-PET 8:00-19:00, SUB 09:00-17:00',
    phone: '+387 51 981 330',
    email: 'info@iutecredit.ba'
  },
  {
    id: '7',
    title: 'IuteCredit Tuzla',
    streetAddress: 'Stupine C1, Tuzla 75000',
    mapUrl: 'https://maps.google.com/maps?ll=44.5298224,18.6924842&z=16&cid=7113685014305608647',
    openingTimes: 'PON-PET 8:00-16:30',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  },
  {
    id: '8',
    title: 'IuteCredit Ilidža',
    streetAddress: 'Ustanička 1, IC Mall, Ilidža 71210',
    mapUrl: 'https://maps.google.com/maps?ll=43.8322776,18.3063159&z=16&cid=1980301990870740716',
    openingTimes: 'PON-PET 8:00-16:30',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  }
]

const en = [
  {
    id: '3',
    title: 'IuteCredit Novo Sarajevo (Sarajevo 3)',
    streetAddress: 'Zmaja od Bosne 50, Općina Novo Sarajevo, Sarajevo 71000',
    mapUrl: 'https://maps.google.com/maps?ll=43.853952,18.389015&z=16&cid=1144787395965979353',
    openingTimes: 'MON-FRI 8:00-19:00; SAT-SUN 09:00-17:00',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  },
  {
    id: '4',
    title: 'IuteCredit Zenica',
    streetAddress: 'Londža br. 92, Zenica 72000',
    mapUrl: 'https://maps.google.com/maps?ll=44.197009,17.914771&z=16&cid=4007873762858220508',
    openingTimes: 'MON-FRI 8:00-16:30',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  },
  {
    id: '5',
    title: 'IuteCredit Istočno Sarajevo',
    streetAddress: 'Hilandarska br. 13, Istočno Sarajevo 71123',
    mapUrl: 'https://maps.google.com/maps?ll=43.819063,18.363945&z=16&cid=5213620382895270726',
    openingTimes: 'MON-FRI 8:00-19:00; SAT 09:00-17:00',
    phone: '+387 51 981 330',
    email: 'info@iutecredit.ba'
  },
  {
    id: '6',
    title: 'IuteCredit Banja Luka',
    streetAddress: 'Gundulićeva br. 52, Banja Luka 78000',
    mapUrl: 'https://maps.google.com/maps?ll=44.773518,17.199645&z=16&cid=868606192412116586',
    openingTimes: 'MON-FRI 8:00-19:00; SAT 09:00-17:00',
    phone: '+387 51 981 330',
    email: 'info@iutecredit.ba'
  },
  {
    id: '7',
    title: 'IuteCredit Tuzla',
    streetAddress: 'Stupine C1, Tuzla 75000',
    mapUrl: 'https://maps.google.com/maps?ll=44.5298224,18.6924842&z=16&cid=7113685014305608647',
    openingTimes: 'MON-FRI 8:00-16:30',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  },
  {
    id: '8',
    title: 'IuteCredit Ilidža',
    streetAddress: 'Ustanička 1, IC Mall, Ilidža 71210',
    mapUrl: 'https://maps.google.com/maps?ll=43.8322776,18.3063159&z=16&cid=1980301990870740716',
    openingTimes: 'MON-FRI 8:00-16:30',
    phone: '+387 33 257 666',
    email: 'info@iutecredit.ba'
  }
]

export default {
  branches: () => {
    return { bs, en }
  }
}
